<script setup>
import { useAuthStore } from '@/stores/auth.js'
import { useUserStore } from '@/stores/user.js'
import { useChatStore } from '@/stores/chat.js'
import { storeToRefs } from 'pinia'
import { messageSetReaction } from '@/api/api.js'
import { inject } from 'vue'

const authStore = useAuthStore()
const userStore = useUserStore()
const chatStore = useChatStore()

const {
  options
} = storeToRefs(authStore)

const {
  userId
} = storeToRefs(userStore)

const {
  chatId,
  allMessages
} = storeToRefs(chatStore)

const message = inject('message')
const close = inject('close')

// heart: ❤️, thumbs_up: 👍, fire: 🔥, joy: 😂, thumbs_down: 👎, sob: 😭
async function setReaction (reaction) {
  try {
    const reactionId = message?.reactionId === reaction ? null : reaction

    await messageSetReaction({
      senderUserId: message.senderId,
      id: message.messageId,
      reactionId: reactionId
    })

    const chatMessage = allMessages.value[chatId.value].find(item => item.messageId === message.messageId)

    if (chatMessage) {
      chatMessage.reactionId = reactionId
    }

    close()
  } catch (error) {
    console.error('Error setting reaction:', error)
  }
}
</script>

<template>
  <div
    v-if="options.messageReactionsEnabled && message.senderId !== userId && [3,0,14].includes(message.type)"
    class="drop-shadow-lg pointer-events-auto rounded-full p-3 bg-white flex items-center gap-3">
    <button
      type="button"
      @click="setReaction('heart')">
      <img class="h-6 w-6 cursor-pointer" src="@/assets/images/emoji/red-heart.png" alt="Red Heart Emoji">
    </button>

    <button
      type="button"
      @click="setReaction('thumbs_up')">
      <img class="h-6 w-6 cursor-pointer" src="@/assets/images/emoji/thumbs-up.png" alt="Thumbs Up Emoji">
    </button>

    <button
      type="button"
      @click="setReaction('fire')">
      <img class="h-6 w-6 cursor-pointer" src="@/assets/images/emoji/fire.png" alt="Fire Emoji">
    </button>

    <button
      type="button"
      @click="setReaction('joy')">
      <img class="h-6 w-6 cursor-pointer" src="@/assets/images/emoji/face-with-tears-of-joy.png" alt="Face with Tears of Joy Emoji">
    </button>

    <button
      type="button"
      @click="setReaction('thumbs_down')">
      <img class="h-6 w-6 cursor-pointer" src="@/assets/images/emoji/thumbs-down.png" alt="Thumbs Down Emoji">
    </button>

    <button
      type="button"
      @click="setReaction('sob')">
      <img class="h-6 w-6 cursor-pointer" src="@/assets/images/emoji/loudly-crying-face.png" alt="Loudly Crying Face Emoji">
    </button>
  </div>
</template>